export const hasNonNegativeAmount = value => {
 if (value == null || !['string','number'].includes(typeof value) || String(value).trim() === '') return false;
 const parsed = Number(String(value).trim().replace(/\s/g,'').replace(/\.(?=\d{3}(?:\D|$))/g,'').replace(',','.'));
 return Number.isFinite(parsed) && parsed >= 0;
};
